import { Modal, Descriptions, Typography, Button, Space } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import { displayMessage } from "../../services/helper";
import DownloadButton from "../../components/buttons/DownloadButton";

const { Text } = Typography;

export const CreateExerciseModal = ({ currentDownloads, isModalVisible, handleOnCloseModal, id }) => {
    const { setShowLoading, mobile_mode } = useContext(GeneralContext);
    const [downloads, setDownloads] = useState(null);
    const [fileName, setFileName] = useState('')
    useEffect(() => {
        loadDownloads();
    }, [currentDownloads]);

    const loadDownloads = async () => {
        try {
            setShowLoading(true);
            setDownloads(currentDownloads);
        } finally {
            setShowLoading(false);
        }
    };
    const renderFile = (field) => {
        return (
            <Space>  
                <DownloadButton downloadedFileName={fileName} file={field} downloadField={field} id={id} fileName={displayMessage("DOWNLOAD")} />
            </Space>
        );
    };


    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('DOWNLOAD')}</div>}
            visible={isModalVisible}
            onCancel={handleOnCloseModal}
            centered={true}
            footer={[]}
            width={mobile_mode ? '90%' : '60%'}
            bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
        >
            {downloads ? (
                <Descriptions column={1} bordered size="small">
                    {downloads.movieUrlApi && (
                        <Descriptions.Item label={displayMessage("MOVIE")}>
                            {renderFile("movieUrl")}
                        </Descriptions.Item>
                    )}
                    {downloads.audioApi && (
                        <Descriptions.Item label={displayMessage("AUDIO")}>
                            {renderFile("audio")}
                        </Descriptions.Item>
                    )}
                    {downloads.openingVideoApi && (
                        <Descriptions.Item label={displayMessage("OPENING_VIDEO")}>
                            {renderFile("openingVideo")}
                        </Descriptions.Item>
                    )}
                    {downloads.replayVideoApi && (
                        <Descriptions.Item label={displayMessage("REPLAY_VIDEO")}>
                            {renderFile("replayVideo")}
                        </Descriptions.Item>
                    )}
                    {downloads.intervalVideoApi && (
                        <Descriptions.Item label={displayMessage("INTERVAL_VIDEO")}>
                            {renderFile("intervalVideo")}
                        </Descriptions.Item>
                    )}
                    {downloads.closingVideoApi && (
                        <Descriptions.Item label={displayMessage("CLOSING_VIDEO")}>
                            {renderFile("closingVideo")}
                        </Descriptions.Item>
                    )}
                </Descriptions>
            ) : (
                <Text type="secondary">{displayMessage("NO_DATA")}</Text>
            )}
        </Modal>
    );
};
